<template>
    <div class="map container">
        <h1>map</h1>
        <h1 v-if="placeData">tthis is {{placeData.location}} + {{address}}</h1>
        <h1 v-if="address">tthis is  {{address}}</h1>
        <div id="floating-panel"></div>

      
     <div class="map">
        <div class="google-map" id = "map">
            

        </div>
        <div id="directionsPanel" ></div>
    </div>
</div>
</template>
<script>
import db from "@/firebase/init"
export default {
    name:"Map",
    data(){
        return{
           address : "fkjnlmd",
           placeData:null,
            
                 lat:null,
                 lng:null,
            
        }
        
    },
    methods:{
        renderMap(){
             if(navigator.geolocation){
            navigator.geolocation.getCurrentPosition(pos => {
                this.lat = pos.coords.latitude
                this.lng = pos.coords.longitude

  
        var directionsDisplay = new google.maps.DirectionsRenderer;
        var directionsService = new google.maps.DirectionsService;
     

        var map = new google.maps.Map(document.getElementById('map'), {
          zoom: 7,
          center: this.placeData.location
        });
        directionsDisplay.setMap(map);
        directionsDisplay.setPanel(document.getElementById('right-panel'));

        var control = document.getElementById('floating-panel');
        control.style.display = 'block';
        map.controls[google.maps.ControlPosition.TOP_CENTER].push(control);

        
          this.calculateAndDisplayRoute(directionsService, directionsDisplay);
          console.log(this.lat,this.lng)
          })
          }
        
    
      
      


}   ,
calculateAndDisplayRoute(directionsService, directionsDisplay) {
 
           var start = new google.maps.LatLng( this.lat, this.lng);
          var end = this.placeData.location
        directionsService.route({
          origin: start,
          destination: end,
          travelMode: 'DRIVING'
        }, function(response, status) {
          if (status === 'OK') {
            directionsDisplay.setDirections(response);
          } else {
            window.alert('Directions request failed due to ' + status);
          }
        });
      }

            

           
  
             
        },
    
    mounted(){
      
              this.renderMap()
           
            
             
        },
        created(){
           let ref = db.collection("places")
        ref.doc(this.$route.params.id).get()
        .then((place) => {
            this.placeData = place.data()
            
        })
        }
    //    beforeMount: async function() {
    //    await created()
    // },
   

    }    
         
 
</script>
<style>
.google-map{
    width:100%;
    height:100%;
    margin:0 auto;
    background: #fff;
    position:absolute;
    top:0;
    left:0;
    z-index:-1;
    
}
.map h1{
    position:relative;
    z-index:2;
}
#directionsPanel{
  float:right;  
  width:30%;
  height: 100%;
}

</style>





// WEBPACK FOOTER //
// src/components/Maps.vue